import { apiClient } from "./api";
import type {
  AnchorProfileResponse,
  LoginResponse,
  PasswordLoginRequest,
} from "@/types";

export const authApi = {
  login(payload: PasswordLoginRequest) {
    return apiClient.post<LoginResponse>("/auth/login", payload);
  },
  refresh(payload: { refresh_token: string }) {
    return apiClient.post<LoginResponse>("/auth/refresh", payload);
  },
  logout() {
    return apiClient.post<void>("/auth/logout");
  },
  me() {
    return apiClient.get<AnchorProfileResponse>("/me");
  },
};
